import GaussClassifier from "./gauss_classifier"

// 引数
// audiodata (Array) : 生の音声データ
// dB_spcs (Array）：パワースペクトル[dB]．2次元配列,shape=(10,2400)で，第一引数がbinの番号，第二引数が周波数
export default function classify_tone(audiodata, dB_spcs){
  const tones_setting = require("./tones.json");
  // console.log(tones_setting);
  const classifier = new GaussClassifier(tones_setting.mu.length, tones_setting.mu, tones_setting.cov);
  
  const pred = [];
  for (let i = 0; i < tones_setting.mu.length; i++) {
    pred[i] = 0;
  } 

  for (let bin = 0; bin < dB_spcs.length; bin++) {
    const x = [];
    for (let i = 0; i < tones_setting.ind48.length; i++) {
      x[i] = dB_spcs[bin][tones_setting.ind48[i]];
    }
    const pred_tmp = classifier.predict(x);
    const doremi2ind = [5, 1, 0, 4, 2, 7, 3, 6];
    for (let c = 0; c < doremi2ind.length; c++) {
      pred[c] += pred_tmp[doremi2ind[c]] / dB_spcs.length;
    }
  }
  let max_pred = 0;
  let max_c = 0;
  for (let c = 0; c < pred.length; c++) {
    if (pred[c] > max_pred) {
      max_pred = pred[c];
      max_c = c;
    }
  }
  // console.log("classify_tone", audiodata, dB_spcs)
  // // 戻り値：音階 0:do 1:re ... 7:hido
  // console.log(pred);
  return max_c;
}